import { Section, SectionTitle, PageHero, CTA, FeatureCard } from "@/components/site/SiteBits";
import { Warehouse, ScanLine, Boxes, PackageCheck, Truck, ClipboardList, Repeat, Bell } from "lucide-react";

const F = [
  { icon: Truck, title: "Receiving", desc: "Inbound booking, gate control and put-away directives." },
  { icon: Boxes, title: "Inventory Tracking", desc: "Real-time stock visibility down to bin location." },
  { icon: ScanLine, title: "Barcode & QR Scanning", desc: "Scan-driven picking, packing and stock transfers." },
  { icon: PackageCheck, title: "Picking & Packing", desc: "Wave and batch picking with accuracy validation." },
  { icon: ClipboardList, title: "Cycle Counting", desc: "Continuous counting to keep inventory accurate." },
  { icon: Repeat, title: "Stock Transfers", desc: "Move stock between warehouses and locations." },
  { icon: Bell, title: "Inventory Alerts", desc: "Low-stock and reorder-level notifications." },
  { icon: Warehouse, title: "Dispatch", desc: "Outbound staging integrated with transport planning." },
];

export default function Warehousing() {
  return (
    <div>
      <PageHero eyebrow="Warehousing & Distribution" title="Smart warehousing, ERP-ready"
        subtitle="Real-time inventory visibility with receiving, put-away, picking, packing, dispatch and cycle counting — built to integrate with your ERP's warehouse management."
        image="/services/warehousing.jpg" />
      <Section>
        <SectionTitle center eyebrow="Warehouse Capabilities" title="From dock to dispatch" />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {F.map((f) => <FeatureCard key={f.title} {...f} />)}
        </div>
      </Section>
      <CTA />
    </div>
  );
}
